import { injectReducer } from 'store/reducers.js'
import { authRoute } from 'helpers/routes'

export const UomsRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'uoms',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/UomsContainer').default

      const actions = require('./modules/uoms').actions
      const reducer = require('./modules/uoms').default

      injectReducer(store, { key: 'uoms', reducer })

      store.dispatch(actions.get())

      cb(null, Container)
    }, 'uoms')
  }
})

export const NewUomRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'uoms/new',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/NewUomContainer').default

      const reducer = require('./modules/uom').default

      injectReducer(store, { key: 'uom', reducer })

      cb(null, Container)
    }, 'uoms')
  }
})

export const EditUomRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'uoms/:id/edit',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/EditUomContainer').default

      const actions = require('./modules/uom').actions
      const reducer = require('./modules/uom').default

      injectReducer(store, { key: 'uom', reducer })

      store.dispatch(actions.get(nextState.params.id))

      cb(null, Container)
    }, 'uoms')
  }
})

export default function (store) {
  return [
    NewUomRoute(store),
    EditUomRoute(store),
    UomsRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/Uoms/index.js